var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-wrap"},[_c('div',{staticClass:"product"},[_c('comHuntingSystem',{on:{"systemTypeReset":_vm.systemTypeReset}}),(_vm.systemType === 2)?_c('hrSystem',{on:{"systemTypeReset":_vm.systemTypeReset,"toHome":_vm.toHome}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }